<template>
    <RouterLink :to="routerLink">
        <div class="card is-full-height link-card">
            <div class="card-header is-full-height">
                <div class="card-header-title">
                    <div class="title is-3 has-text-grey py-6 pl-2">
                        <slot>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </RouterLink>
</template>

<script>
export default {
    name: "LinkCard",
    props: {
        routerLink: {
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
.link-card{
    @include pop-on-hover;
}
</style>